import { render, staticRenderFns } from "./Gebruikers.vue?vue&type=template&id=4c71ecf9&"
import script from "./Gebruikers.vue?vue&type=script&lang=js&"
export * from "./Gebruikers.vue?vue&type=script&lang=js&"
import style0 from "./Gebruikers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports